import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'
import { DateRange } from '../../lib/types/DateRange'
import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'

export type DividendMetricsType = Array<{
  upload_id: number
  date: string
  amount_local: number
  amount_target: number
  local_currency_code: string
  local_currency: string
  local_currency_symbol: string
  target_currency_code: string
  target_currency: string
  target_currency_symbol: string
}>
export const useGetDividendMetrics = ({
  dateRange,
}: {
  dateRange: DateRange
}): UseQueryResult<DividendMetricsType, Error> => {
  const queryParams = useBuildQueryParams(dateRange.dateRange)

  return useQuery(['reports', 'dividends', 'metrics', { queryParams }], () =>
    request<DividendMetricsType>({
      url: '/reports/dividends/metrics',
      method: 'GET',
      params: {
        ...queryParams,
      },
    }),
  )
}
